import axios from "axios";

import { config } from "config";
import store from "store";
import {
  dashboardAPIDown,
  logoutUser,
  backupPlansAPIDown
} from "store/actions";
import { decryptData } from "utils";

// Ajax instance for Web API server
export const appInstance = axios.create({
  baseURL: config.API_URL
});

// Ajax instance for Web API server
export const appInstanceV2 = axios.create({
  baseURL: config.API_URL_V2
});

const appInstancesArray = [appInstance, appInstanceV2];

appInstancesArray.map(instance =>
  instance.interceptors.request.use(req => {
    if (
      !localStorage.getItem("rememberMe") ||
      (!JSON.parse(localStorage.getItem("rememberMe")).rememberMe &&
        new Date(
          new Date(
            JSON.parse(localStorage.getItem("rememberMe")).loggedInTime
          ).getTime() +
            60 * 60 * 24 * 1000
        ).getTime() < new Date().getTime())
    ) {
      store.dispatch(logoutUser(false));
    } else {
      req.headers.common["Content-Type"] = "application/json";
      if (localStorage.getItem("token")) {
        req.headers.Authorization = localStorage.getItem("token");
        req.params = {
          ...req.params,
          loginId: decryptData(localStorage.getItem("mirrorId"))
        };
      }
    }

    return req;
  })
);

const dashboardUrls = ["/settings/all", "/account/details", "/backup/list"];

const errorHttp = [500, 501, 412, 404, 400];

const settingUrls = [
  "/restore/recoveryPoints",
  "/backup/settings",
  "/restore/filesList",
  "/restore/filesSearch",
  "/logs/all"
];

const backupPlansUrls = [
  "/backupPlan/all",
  "/backupPlan/defaultSettings",
  "backupPlan/settings"
];

appInstancesArray.map(instance =>
  instance.interceptors.response.use(
    res => res,
    error => {
      const errorRes = error.response;

      if (errorRes) {
        errorRes.data =
          typeof error.response.data === "string"
            ? error.response.data
            : "Unable to connect to server";
        if (
          dashboardUrls.includes(error.response.config.url) &&
          errorHttp.includes(error.response.status) &&
          error.response.config.method !== "delete"
        ) {
          store.dispatch(
            dashboardAPIDown({
              status: errorRes.status,
              msg: errorRes.data
            })
          );
        }
        if (
          settingUrls.includes(error.response.config.url) &&
          (error.response.status === 500 || error.response.status === 400)
        ) {
          store.dispatch(
            dashboardAPIDown({
              status: errorRes.status,
              msg: errorRes.data
            })
          );
        }
        if (
          backupPlansUrls.includes(error.response.config.url) &&
          (error.response.status === 500 ||
            error.response.status === 400 ||
            error.response.status === 404)
        ) {
          store.dispatch(
            backupPlansAPIDown({
              status: errorRes.status,
              msg: errorRes.data
            })
          );
        }
      }

      return errorRes;
    }
  )
);

// DAV API instance for ajax call
const whiteListUrls = [
  "/login/",
  "/register/",
  "user/validatePwdToken",
  "user/password/updatepwd",
  "subUser/validateSubUserToken",
  "subUser/activateuser"
];

export const davInstance = axios.create({
  baseURL: config.DAV_URL
});

davInstance.interceptors.request.use(req => {
  req.headers.common["Content-Type"] = "application/json";
  if (!whiteListUrls.includes(req.url) && localStorage.getItem("token"))
    req.params = {
      ...req.params,
      token: localStorage.getItem("token"),
      mirrorId: decryptData(localStorage.getItem("mirrorId"))
    };

  return req;
});

davInstance.interceptors.response.use(
  req => {
    if (req.data.code === 403) {
      store.dispatch(logoutUser(false));
    } else {
      return req;
    }
  },
  error => {
    return error.response;
  }
);

export const virtInstance = axios.create({
  baseURL: config.VIRT_URL
});

virtInstance.interceptors.request.use(req => {
  req.headers.common["Content-Type"] = "application/json";
  if (localStorage.getItem("token")) {
    req.headers.Authorization = localStorage.getItem("token");
    req.params = {
      ...req.params,
      username: decryptData(localStorage.getItem("mirrorId"))
    };
  }

  return req;
});

virtInstance.interceptors.response.use(
  req => {
    if (req.data.code === 401) {
      store.dispatch(logoutUser(false));
    } else {
      return req;
    }
  },
  error => {
    if (error.response.status === 401) {
      store.dispatch(logoutUser(false));
    } else {
      return error.response;
    }
  }
);
